<template>
  <nav class="navbar navbar-expand-lg z-depth-0 px-0 sticky-top py-0" style="background-color: #f5f5f6">
    <div style="width: 960px; margin-left: auto; margin-right: auto;" class="navbar navbar-expand-lg z-depth-0 px-0 py-0">
      <div class="ml-3">
        <a class="navbar-brand mr-0 py-0" @click="to('Landing')"><img src="../assets/logofyfnuevoR.jpg" alt="" height="100px" class=""></a>
      </div>
      <button style="color: black" class="navbar-toggler" type="button" data-toggle="collapse"
              data-target="#navbarTogglerDemo01"
              aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"><i class="fas fa-align-justify"></i></span>
      </button>
      <div class="collapse navbar-collapse " id="navbarTogglerDemo01">
        <ul class="navbar-nav mr-auto ml-auto mt-lg-0">
          <li class="nav-item mx-2">
            <a class="nav-link" @click="to('Landing')">Inicio</a>
          </li>
          <li class="nav-item mx-2">
            <a class="nav-link " href="#fyf"  @click="to('Landing')">Acerca de</a>
          </li>
          <li class="nav-item mx-2">
            <a class="nav-link" href="#soluciones" @click="to('Landing')">Soluciones</a>
          </li>
          <li class="nav-item mx-2">
            <a class="nav-link" @click="to('Idea')">Desarrolla tu idea</a>
          </li>
          <li class="nav-item mx-2">
            <a class="nav-link"  @click="to('Landing')" href="#contact">Solicita una demo</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "Navbar",
    methods:{
      to(route){
        this.$router.push({name:route})
      }
    }
  }
</script>

<style scoped>
  .nav-link {
    color: black;
  }

  .btn {
    background-color: var(--primaryDarkColor) !important;
    border-radius: inherit !important;
  }

  nav {
    box-shadow: 0 5px 10px 0 rgba(0, 0, 0, .2), 0 6px 7px 0 rgba(0, 0, 0, .1) !important;
    z-index: 20 !important;
  }
</style>
